export default __webpack_public_path__ + "static/media/MG.37cf8d7f.svg";